import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {
  Select,
  MenuItem,
  Button,
  TextField,
  Grid,
  Box,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";

const AddUser = ({
  handleClose,
  openDialog,
  isEditMode,
  register,
  handleSubmit,
  errors,
  onAddEditUserSubmit,
  departmentList,
  roleList,
  userTypeList,
  formData,
  setDeptName,
  setUserTypeName,
  setRoleName,
  isUpdateButton,
  setIsUpdateButton,
  onSelectDepartment,
  disableUserType,
  loginUserInfo,
  setValue
}) => {
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose}fullWidth={1}
        maxWidth={"sm"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>{!isEditMode ? "Add User" : "Edit User"}</b>
            </div>
            <CloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 2 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={1}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 2 }}>
                        {/* <FormLabel
                      className="stepperFormLabel" sx={{ width: "220px" }}
                      required={true}
                    >
                      User Code
                    </FormLabel> */}
                        <TextField
                          className="stepperFormInput"
                          label="User Code"
                          name="employeeId"
                          fullWidth
                          placeholder="Enter user code"
                          size="small"
                          autoComplete="off"
                          {...register("employeeId")}

                          error={Boolean(errors?.employeeId?.message)}
                          helperText={errors?.employeeId?.message}
                          onChange={(e) => {setIsUpdateButton(false);
                            if(e.target.value){
                              setValue("isEmployeId",true)
                            }
                            else{
                              setValue("isEmployeId",false)
                            }
                          }}

                        />
                      </Grid>

                      <Grid item xs={6} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-error-label"
                            sx={{ marginTop: "-6px" }}
                          >
                            Department
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            id="demo-simple-select"
                            label="Department"
                            name="deptId"
                            fullWidth
                            defaultValue={formData.deptId}
                            size="small"
                            autoComplete="off"
                            {...register("deptId", { required: true })}
                            error={Boolean(errors?.deptId)}
                            helperText={errors?.deptId?.message}
                            onChange={() => setIsUpdateButton(false)}
                          >
                            {departmentList &&
                              departmentList.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.departmentId}
                                    sx={{ width: "100%" }}
                                    value={d.departmentId}
                                    size="small"
                                    onClick={() => {
                                      onSelectDepartment(d.departmentId);
                                      setDeptName(d.name);
                                    }}
                                  >
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.deptId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        {/* <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      required={true}
                    >
                      First Name   
                    </FormLabel> */}
                        <TextField
                          className="stepperFormInput"
                          label="First Name"
                          name="firstName"
                          placeholder="Enter first name"
                          fullWidth
                          required
                          size="small"
                          autoComplete="off"
                          {...register("firstName", { required: true })}
                          error={Boolean(errors?.firstName)}
                          helperText={errors?.firstName?.message}
                          onChange={() => setIsUpdateButton(false)}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        {/* <FormLabel
                      required={true}
                      sx={{ width: "220px" }}
                      className="stepperFormLabel"
                    >
                      Last Name
                    </FormLabel> */}
                        <TextField
                          className="stepperFormInput"
                          label="Last Name"
                          name="lastName"
                          placeholder="Enter last name"
                          fullWidth
                          size="small"
                          autoComplete="off"
                          {...register("lastName", { required: true })}
                          error={errors?.lastName}
                          helperText={errors?.lastName?.message}
                          onChange={(e) => {setIsUpdateButton(false)
                            if(e.target.value){
                              setValue("isLastName",true)
                            }
                            else{
                              setValue("isLastName",false)
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        {/* <FormLabel
                      required={true}
                      sx={{ width: "220px" }}
                      className="stepperFormLabel"
                    >
                      Email{" "}
                    </FormLabel> */}
                        <TextField
                          className="stepperFormInput"
                          label="Email"
                          name="email"
                          placeholder="Enter email address"
                          fullWidth
                          required
                          size="small"
                          autoComplete="off"
                          {...register("email", { required: true })}
                          error={errors?.email}
                          helperText={errors?.email?.message}
                          onChange={() => setIsUpdateButton(false)}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        {/* <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      required={true}
                    >
                      Role
                    </FormLabel> */}
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-label"
                            sx={{ marginTop: "-6px" }}
                          >
                            Role
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="role"
                            name="roleId"
                            fullWidth
                            defaultValue={formData.roleId}
                            required
                            size="small"
                            autoComplete="off"
                            {...register("roleId", { required: true })}
                            error={errors?.roleId}
                            helperText={errors?.roleId?.message}
                            onChange={() => setIsUpdateButton(false)}
                          >
                            {roleList &&
                              roleList.map((r) => {
                                return (
                                  <MenuItem
                                    native
                                    key={r.functionId}
                                    sx={{ width: "100%" }}
                                    value={r.functionId}
                                    size="small"
                                    onClick={() => setRoleName(r.name)}
                                  >
                                    {r.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.roleId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        {/* <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      required={true}
                    >
                      User Type
                    </FormLabel> */}
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-label"
                            sx={{ marginTop: "-6px" }}
                          >
                            User Type
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="User Type"
                            name="userTypeId"
                            fullWidth
                            required
                            disabled={disableUserType}
                            defaultValue={formData.userTypeId}
                            size="small"
                            autoComplete="off"
                            {...register("userTypeId", { required: true })}
                            error={Boolean(errors?.userTypeId)}
                            helperText={errors?.userTypeId?.message}
                            onChange={() => setIsUpdateButton(false)}
                          >
                            {userTypeList &&
                              userTypeList.map((u,index) => {
                                return (
                                  <MenuItem
                                    native
                                    key={u.userTypeId}
                                    sx={{ width: "100%" }}
                                    value={u.userTypeId}
                                    disabled={loginUserInfo.userType === "Domain Admin" ? u.userTypeId===1:false}
                                    size="small"
                                    onClick={() => setUserTypeName(u.name)}
                                  >
                                    {u.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.userTypeId?.message}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        {/* <FormLabel
                      className="stepperFormLabel"
                      sx={{ width: "220px" }}
                      // required={true}
                    >
                      Is Active?
                    </FormLabel> */}
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-label"
                            sx={{ marginTop: "-6px" }}
                          >
                            Is Active?
                          </InputLabel>
                          <Select
                            className="stepperFormInput"
                            label="Is Active?"
                            name="active"
                            fullWidth
                            // required
                            defaultValue={
                              Object.prototype.hasOwnProperty.call(
                                formData,
                                "active"
                              )
                                ? Boolean(formData.active)
                                : true
                            }
                            // defaultValue={Boolean(formData.active)}
                            size="small"
                            autoComplete="off"
                            {...register("active")}
                            onChange={() => setIsUpdateButton(false)}
                            // error={Boolean(errors?.active)}
                            // helperText={errors?.active?.message}
                          >
                            <MenuItem
                              native
                              sx={{ width: "100%" }}
                              value={true}
                              size="small"
                            >
                              Yes
                            </MenuItem>
                            <MenuItem
                              native
                              sx={{ width: "100%" }}
                              value={false}     
                              size="small"
                            >
                              No
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={6} sx={{ pr: 1 }}>
                        <TextField
                          className="stepperFormInput"
                          label="Mobile Number"
                          name="mobileNumber"
                          placeholder="Enter mobile number"
                          fullWidth
                          size="small"
                          autoComplete="off"
                          {...register("mobileNumber")}
                          error={Boolean(errors?.mobileNumber)}
                          helperText={errors?.mobileNumber?.message}
                          onChange={(e) =>{ setIsUpdateButton(false);
                            if(e.target.value){
                              setValue("isMobileNo",true)
                            }
                            else{
                              setValue("isMobileNo",false)
                            }
                            }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 1, pl: 53 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddEditUserSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
            {/* <Grid>
              <UserEditRolesAccessPage
                userRolesAccessDetails={userRolesAccessDetails}
                setLoading={setLoading}
                showNotification={showNotification}
                userId={userId}
                handleClose={handleClose}
                EditUserRoleAccessInsideUsersPageService={EditUserRoleAccessInsideUsersPageService}
              />
            </Grid> */}
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddUser;
